import { useEffect, useState } from "react";
import { debounce } from "lodash";

export const useActiveSection = (sectionIds, delay = 100) => {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight;
      const viewportMidpoint = viewportHeight / 2;

      let mostVisibleSection = null;
      let largestVisibleArea = 0;

      sectionIds.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          const rect = section.getBoundingClientRect();
          const sectionTop = rect.top;
          const sectionBottom = rect.bottom;

          const visibleTop = Math.max(sectionTop, 0);
          const visibleBottom = Math.min(sectionBottom, viewportHeight);
          const visibleHeight = Math.max(visibleBottom - visibleTop, 0);

          const isViewportMidInSection =
            sectionTop <= viewportMidpoint && sectionBottom >= viewportMidpoint;

          if (isViewportMidInSection && visibleHeight > largestVisibleArea) {
            largestVisibleArea = visibleHeight;
            mostVisibleSection = id;
          }
        }
      });

      if (mostVisibleSection && mostVisibleSection !== activeSection) {
        setActiveSection(mostVisibleSection);
      }
    };

    const debouncedScrollHandler = debounce(handleScroll, delay);

    window.addEventListener("scroll", debouncedScrollHandler);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", debouncedScrollHandler);
    };
  }, [sectionIds, delay, activeSection]);

  return activeSection;
};
